"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function format(euros) {
    const sign = euros.cents < 0 ? -1 : 1;
    const absValue = Math.abs(euros.cents);
    const wholes = Math.floor(absValue / 100) * sign;
    const remainder = absValue % 100;
    return remainder > 0
        ? `${wholes},${remainderToString(remainder)}`
        : `${wholes}`;
}
exports.format = format;
function remainderToString(remainder) {
    const x = `${remainder}`;
    return x.length >= 2 ? x.substring(0, 2) : '0'.repeat(2 - x.length) + x;
}
exports.toCurrency = (e) => `${format(e)} €`;
